var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayLikes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4449 5.5577C11.105 5.44015 10.7447 5.39348 10.3861 5.42056C10.0275 5.44765 9.67823 5.54793 9.35988 5.7152C9.24587 5.78103 9.11653 5.81568 8.98488 5.81568C8.85323 5.81568 8.7239 5.78103 8.60988 5.7152C8.0376 5.41624 7.37442 5.34137 6.74988 5.5052C6.23375 5.63802 5.77628 5.93835 5.44918 6.3591C5.12208 6.77986 4.94383 7.29726 4.94238 7.8302C4.94238 10.3802 7.41738 11.8727 8.51238 12.3977C8.67186 12.4682 8.84428 12.5046 9.01863 12.5046C9.19298 12.5046 9.36541 12.4682 9.52488 12.3977C10.6049 11.9477 13.0199 10.6277 13.0724 7.7702C13.058 7.27974 12.8945 6.80531 12.6038 6.41005C12.313 6.0148 11.9088 5.71749 11.4449 5.5577Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayLikes);
export default __webpack_public_path__ + "static/media/gray-likes.66861d10828d4d019ba8df01925001c7.svg";
export { ForwardRef as ReactComponent };